import angular from 'angular';
import uiRouter from 'angular-ui-router';
import template from './breadcrumb.html';

class BreadcrumbController {
    constructor($state, $stateParams) {
        this.$state = () => $state;
        this.$stateParams = () => $stateParams;
    }

    $onInit() {
        this.$state = this.$state();
        this.stateParams = this.$stateParams();
        this.states = this.$state.$current.path.filter((s) => !s.abstract);
    }
}

BreadcrumbController.$inject = ['$state', '$stateParams'];

const BreadcrumbComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: BreadcrumbController,
    controllerAs: 'vm'
};


const breadcrumb = angular.module('breadcrumb', [uiRouter]);
breadcrumb.component('breadcrumb', BreadcrumbComponent);

export {breadcrumb};



// WEBPACK FOOTER //
// ./app/components/common/breadcrumb/breadcrumb.js